const LABELS = {
    casing: "Casing",
    casingOD: "Casing OD",
    casingWeight: "Casing weight",
    casingID: "Casing ID",
    casingDriftID: "Casing drift ID",
    liner: "Liner",
    linerOD: "Liner OD",
    linerWeight: "Liner weight",
    linerID: "Liner ID",
    linerTopMD: "Liner top @MD",
    tubing: "Tubing",
    tubingOD: "Tubing OD",
    tubingType: "Tubing type",
    tubingWeight: "Tubing weight",
    tubingID: "Tubing ID",
    wellTrajectory: "Well trajectory",
};

export default LABELS;